import { Checkbox, CheckboxProps, styled } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface CustomCheckBoxProps extends Omit<CheckboxProps, 'icon' | 'checkedIcon'> {
    borderColor?: string;
    backgroundColor?: string;
    checkedBackgroundColor?: string;
    checkedBorderColor?: string;
}

// Custom icon component for unchecked state (rounded square with border)
const UncheckedIcon = ({ borderColor = colors.greyPreset[30] }: { borderColor?: string }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="18" height="18" rx="4" fill="none" stroke={borderColor} strokeWidth="1.5" />
        </svg>
    );
};

// Custom icon component for checked state (rounded square with background and white checkmark)
const CheckedIcon = ({
    backgroundColor = colors.primaryLight[100],
    borderColor = colors.primaryLight[100],
}: {
    backgroundColor?: string;
    borderColor?: string;
}) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            // style={{ borderRadius: '8px' }}
        >
            <rect
                x="1"
                y="1"
                width="18"
                height="18"
                rx="4"
                fill={backgroundColor}
                stroke={borderColor}
                strokeWidth="1"
            />
            <path
                d="M6 10L9 13L14 7"
                stroke={colors.fullWhite}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const StyledCheckbox = styled(Checkbox)({
    padding: 0,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '& .MuiSvgIcon-root': {
        borderRadius: '8px',
    },
});

export const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({
    borderColor = colors.greyPreset[80],
    backgroundColor,
    checkedBackgroundColor = colors.primaryLight[100],
    checkedBorderColor,
    ...props
}) => {
    const finalCheckedBg = backgroundColor || checkedBackgroundColor;
    const finalCheckedBorder = checkedBorderColor || checkedBackgroundColor;

    return (
        <StyledCheckbox
            {...props}
            icon={<UncheckedIcon borderColor={borderColor} />}
            checkedIcon={<CheckedIcon backgroundColor={finalCheckedBg} borderColor={finalCheckedBorder} />}
        />
    );
};
